import React from 'react';

import {
  FEATURE_GATES,
  PermissionFilter,
  GlobalFeatureGateFilter
} from '@sopranodesign/pulse-auth';
import {
  Panel,
  PageWrapper
} from '@sopranodesign/pulse-components';

import { Jira } from '../Components';

const JiraPage = () => (
  <PageWrapper beta="true" header="Jira" subheader="Configure your Jira">
    <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI}>
      <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI_JIRA}>
        <PermissionFilter can="view generative ai resource">
          <Panel>
            <Jira />
          </Panel>
        </PermissionFilter>
      </GlobalFeatureGateFilter>
    </GlobalFeatureGateFilter>
  </PageWrapper>
);

export default JiraPage;
